export const PATH_PARAM = /:\w+(?=\/?)/
export const FOLIO_VALIDATOR = /^(\W|^)CED[0-9]{4}[-][a-zA-Z0-9\--]{10}(\W|$)/
